var exports = {
  "kL": "xfd349460--4c8662--container",
  "L1": "xfd349460--4c8662--category",
  "Sl": "xfd349460--4c8662--image",
};

module.exports = exports;
